import { Component, Inject, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { Subscription } from 'rxjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { RecordPaymentComponent } from '../record-payment/record-payment.component';

@Component({
  selector: 'sm-credit-details',
  templateUrl: './credit-details.component.html',
  styleUrls: ['./credit-details.component.scss']
})
export class CreditDetailsComponent implements OnInit, OnDestroy {
  invoiceDetails: any = []
  private _apiSubscription: Subscription = new Subscription();
  @ViewChild('captureContainer', { static: false }) captureContainer!: ElementRef;
  constructor( @Inject(MAT_DIALOG_DATA) public parentData: any, private _apiService: ApiService, private _modelRef: MatDialog) { }
  creditDetails:any = []
  ngOnInit(): void { 
    this.creditDetails = []
    let data = this.parentData.data
    data.transtionsInfo = (typeof data.transtionsInfo == 'string') ? JSON.parse(data.transtionsInfo) : data.transtionsInfo
    this.creditDetails.push(data)
    console.log(this.creditDetails);
    

    
  }

  openRecordPayment(){

    let data = {
      appointmentHash: this.parentData.data,
      price: this.invoiceDetails[0].total_price,
    }
    this._modelRef.open(RecordPaymentComponent, {
      width: '400px',
      data: {
        title: 'Record Payment',
        ref: this._modelRef,
        data: data
      },
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }

  captureScreenshot() {
    const element = document.getElementById('capture'); // Replace 'elementId' with the actual ID of the element you want to capture
    html2canvas(element!).then((canvas:any) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 0, 0, canvas.width * 0.75, canvas.height * 0.75); // You might need to adjust the dimensions
      pdf.save('screenshot.pdf');
    });
  }

  captureScreen() {

  //   html2canvas(this.captureContainer.nativeElement, {
  //     allowTaint : true,
  //     useCORS : true 
  //  }).then(canvas => {
  //     // Convert canvas to an image URL
  //     const screenshotUrl = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF();
  //     pdf.addImage(screenshotUrl, 'PNG', 0, 0, canvas.width * 1, canvas.height * 1); // You might need to adjust the dimensions
  //     pdf.save('screenshot.pdf');
  //   });

  let pdf = new jsPDF('p', 'pt', 'a4')
  pdf.html(this.captureContainer.nativeElement, { callback:(pdf) => {
pdf.save(this.invoiceDetails[0].inv_no + ".pdf")
  } 
})


  }

}
